<div>
    <div class="main-container">
        <div class="editor-container editor-container_classic-editor">
            <div class="editor-container__editor">
                <div>
                    <ckeditor
                            [editor]="Editor!"
                            [formControl]="control"
                            *ngIf="isLayoutReady"
                            (change)="onChange($event)">
                    </ckeditor>
                </div>
            </div>
        </div>
    </div>
</div>